import React from 'react';
import { UserPlus } from 'lucide-react';
import { NewUser } from '../types/AdminTypes';

interface CreateUserModalProps {
  show: boolean;
  onClose: () => void;
  newUser: NewUser;
  setNewUser: (user: NewUser) => void;
  onSubmit: () => Promise<void>;
}

const CreateUserModal: React.FC<CreateUserModalProps> = ({ 
  show, 
  onClose, 
  newUser, 
  setNewUser, 
  onSubmit 
}) => {
  if (!show) return null;

  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setNewUser({ ...newUser, email: e.target.value });
  };

  const handlePasswordChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setNewUser({ ...newUser, password: e.target.value });
  };

  const handleFullNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setNewUser({ ...newUser, full_name: e.target.value });
  };

  const handleRoleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setNewUser({ ...newUser, role: e.target.value as 'admin' | 'auditor' });
  };

  return (
    <div className="fixed inset-0 bg-gray-900/50 backdrop-blur-sm flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-3xl shadow-2xl w-full max-w-md animate-in zoom-in duration-300">
        <div className="relative p-6 sm:p-8 pb-0">
          <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500 rounded-t-3xl"></div>
          <div className="flex items-center justify-between">
            <div>
              <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-2">Nouvel Utilisateur</h3>
              <p className="text-gray-600 text-sm sm:text-base">Ajoutez un membre à votre équipe</p>
            </div>
            <div className="p-3 bg-gradient-to-r from-blue-500 to-purple-600 rounded-2xl">
              <UserPlus className="w-5 h-5 sm:w-6 sm:h-6 text-white" />
            </div>
          </div>
        </div>

        <div className="p-6 sm:p-8 space-y-6">
          <div>
            <label className="block text-sm font-bold text-gray-900 mb-3">Nom complet *</label>
            <input
              type="text"
              value={newUser.full_name}
              onChange={handleFullNameChange}
              className="w-full px-4 py-3 sm:py-4 bg-gray-50 border-0 rounded-2xl focus:ring-2 focus:ring-blue-500 focus:bg-white transition-all placeholder-gray-400 text-sm sm:text-base"
              placeholder="Jean Dupont"
              autoComplete="off"
            />
          </div>
          
          <div>
            <label className="block text-sm font-bold text-gray-900 mb-3">Adresse email *</label>
            <input
              type="email"
              value={newUser.email}
              onChange={handleEmailChange}
              className="w-full px-4 py-3 sm:py-4 bg-gray-50 border-0 rounded-2xl focus:ring-2 focus:ring-blue-500 focus:bg-white transition-all placeholder-gray-400 text-sm sm:text-base"
              placeholder="jean.dupont@focal.com"
              autoComplete="off"
            />
          </div>
          
          <div>
            <label className="block text-sm font-bold text-gray-900 mb-3">Mot de passe *</label>
            <input
              type="password"
              value={newUser.password}
              onChange={handlePasswordChange}
              className="w-full px-4 py-3 sm:py-4 bg-gray-50 border-0 rounded-2xl focus:ring-2 focus:ring-blue-500 focus:bg-white transition-all placeholder-gray-400 text-sm sm:text-base"
              placeholder="••••••••••••"
              autoComplete="off"
            />
          </div>
          
          <div>
            <label className="block text-sm font-bold text-gray-900 mb-3">Rôle</label>
            <select
              value={newUser.role}
              onChange={handleRoleChange}
              className="w-full px-4 py-3 sm:py-4 bg-gray-50 border-0 rounded-2xl focus:ring-2 focus:ring-blue-500 focus:bg-white transition-all text-sm sm:text-base"
            >
              <option value="auditor">🔍 Auditeur</option>
              <option value="admin">👑 Administrateur</option>
            </select>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row space-y-3 sm:space-y-0 sm:space-x-4 p-6 sm:p-8 pt-0">
          <button
            onClick={onClose}
            className="flex-1 py-3 sm:py-4 px-6 bg-gray-100 text-gray-700 rounded-2xl font-bold hover:bg-gray-200 transition-all duration-200 text-sm sm:text-base"
          >
            Annuler
          </button>
          <button
            onClick={onSubmit}
            className="flex-1 py-3 sm:py-4 px-6 bg-gradient-to-r from-blue-600 to-purple-600 text-white rounded-2xl font-bold hover:shadow-lg hover:scale-105 transform transition-all duration-200 text-sm sm:text-base"
          >
            Créer
          </button>
        </div>
      </div>
    </div>
  );
};

export default CreateUserModal;